import './OnScreenReports.scss';
import React, { useEffect, useState } from 'react';
import CircularButton, { CustomLoadingButton } from '../ui/CustomButton.jsx';
import newRequest from '../../utils/newRequest.js';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Home, MoveRight } from "lucide-react";
import { FiSearch } from "react-icons/fi";
import { qilloIconMap } from '../../utils/iconMapping.js';
import PdfPreview from '../pdfPreview/PdfPreview.jsx';
import { motion } from "framer-motion";
import { MdDownload, MdMarkEmailUnread, MdClose, MdAlternateEmail } from "react-icons/md";
import { ScaleLoader } from 'react-spinners';
import EmailComponent from '../emailComponent/EmailComponent.jsx';
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@mui/material";
import DOMPurify from 'dompurify';
import { useTranslation } from "react-i18next";
import { ImWhatsapp } from 'react-icons/im';
import { BsFillSendFill } from 'react-icons/bs';
import { isValidMobileNumber, logData } from '../../utils/genericFunctions.js';
import { showToast } from '../../toastService.js';


const OnScreenReports = ({ reportGroup, documentData, reportsList }) => {

    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(false);
    const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [reports, setReports] = useState([]);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [emailDialogOpen, setEmailDialogOpen] = useState(false);
    const [emailData, setEmailData] = useState(null);
    const [pdfPreviewDialogOpen, setPdfPreviewDialogOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [binaryDocid, setBinaryDocid] = useState(null);
    const [selectedFormats, setSelectedFormats] = useState({});
    const [backgroundSettings, setBackgroundSettings] = useState({});
    const [whatsAppDialogOpen, setWhatsAppDialogOpen] = useState(false);

    const [to, setTo] = useState(documentData?.clientPhoneNo || "");
    const [message, setMessage] = useState("");
    const [charCount, setCharCount] = useState(0);

    const handleFormatChange = (reportId, newFormat) => {
        setSelectedFormats((prev) => ({
            ...prev,
            [reportId]: newFormat
        }));
    };

    const handleBackgroundToggle = (reportId) => {
        setBackgroundSettings((prev) => ({
            ...prev,
            [reportId]: prev[reportId] === "Y" ? "N" : "Y"
        }));
    };


    const handleContentChange = (e) => {
        const value = e.target.value;
        setMessage(value);
        setCharCount(value.length);
    };

    const handleDocumentShare = async () => {
        try {

            if (!to) {
                setNotifyDialogTitle(t("note"));
                setNotifyDialogText(`Please specify valid WhatsApp Number!`);
                setIsNotifyDialogOpen(true);
                return false;
            } else {
                if (!isValidMobileNumber(to)) {
                    setNotifyDialogTitle(t("note"));
                    setNotifyDialogText(`Please specify valid WhatsApp Number!`);
                    setIsNotifyDialogOpen(true);
                    return false;
                }
            }

            if (!message) {
                setNotifyDialogTitle(t("note"));
                setNotifyDialogText(`Please enter message!`);
                setIsNotifyDialogOpen(true);
                return false;
            }

            setIsProcessingTitle(t('sharingTo', { param1: to }));
            setIsProcessing(true);

            const res = await newRequest.post("/exportFiles/sendReportToTwilio", {
                report_id: binaryDocid,
                to,
                message
            });

            setIsProcessing(false);

            if (res.data.msg === "sent") {
                setMessage("");
                setWhatsAppDialogOpen(false);
                showToast(t('sharedWith', { param1: to }), "success");
            } else {
                console.error("Error details:", res.data?.error);
                showToast("error sharing the file!", "error");
            }

        } catch (error) {
            setIsProcessing(false);
            console.error("Error sharing document:", error);
        }
    };

    const fetchEmails = () => {

    };

    const fetchReports = async () => {
        try {

            console.log(`0 reportGroup ... ${reportGroup}`);

            const res = await newRequest.post("/reportGroup/getReports", { rd_rep_group: reportGroup });
            const apiReports = Array.isArray(res.data) ? res.data : [];
            const listReports = Array.isArray(reportsList) ? reportsList : [];
            // logData("listReports", listReports);
            // logData("apiReports", apiReports);
            const formattedListReports = listReports.map((rep, index) => ({
                rd_org_code: rep?.report_org_code,
                rd_rep_group: reportGroup,
                rd_rep_key: "",
                rd_code: index + 1,
                rd_name: rep?.report_title || "",
                rd_ref: "",
                rd_description: rep?.report_desc,
                rd_category: "General",
                rd_type: "Report",
                rd_output_type: "PDF",
                rd_file_path: rep?.report_file_path || "",
                rd_file_name: rep?.report_file_name || "",
                rd_procedure_name: "",
                rd_endpoint: rep?.report_endpoint || "",
                rd_icon: rep?.report_icon || "SiOpenlayers",
                rd_parameters: [],
                rd_allow_background: rep?.report_background || "N",
                rd_change_format: rep?.report_format_change || "N",
                rd_enabled: rep?.report_enabled,
                rd_order: rep?.report_order || 0
            }));
            // logData("formattedListReports", formattedListReports);
            // merge both (keep duplicates if same report exists)
            const mergedReports = [...formattedListReports, ...apiReports];

            // if both empty, mergedReports will just be []
            setReports(mergedReports);

        } catch (error) {
            console.error(error);
            setReports([]); // fallback to empty
        }
    };


    const filteredReports = reports?.filter(
        (item) =>
            item.rd_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            item.rd_description?.toLowerCase().includes(searchTerm?.toLowerCase())
    );

    useEffect(() => {
        fetchReports();
    }, [reportGroup]);

    return (
        <div className="on-screen-reports">
            {/* <span>{reports.map(report => report.report_name).join(", ")}</span> */}
            <div className="reports-toolbar">
                {/* show search only if reports are more than 4 */}
                {reports?.length > 4 &&
                    <div className="search-input-wrapper" style={{ width: "70%" }}>
                        <FiSearch className="search-input-icon" />
                        <input
                            className="search-input"
                            type="text"
                            placeholder={`${t('search')} ${t('report')}`}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm?.length > 0 && (
                            <MdClose onClick={(e) => setSearchTerm("")} className="search-input-icon" />
                        )}
                        {searchTerm?.length === 0 && (
                            <span className="search-input-icon" />
                        )}
                    </div>}
            </div>
            {filteredReports?.length > 0 && (
                <div className="reports-wrapper">
                    {filteredReports.map((report) => {
                        const IconComponent = qilloIconMap[report?.report_icon] || Home;

                        const currentFormat =
                            selectedFormats[report._id] || report.report_format || "pdf";

                        const currentBackground =
                            backgroundSettings[report._id] || report.report_background || "N";

                        return (
                            <div
                                key={report?._id}
                                className="sub-menu-item"
                                onClick={async () => {
                                    try {
                                        setIsProcessingTitle(t('runningReport', { param1: report?.rd_name }));
                                        setIsProcessing(true);

                                        await newRequest.post(
                                            "/trace/add", {
                                            trc_action_on: "Document",
                                            trc_doc_type: documentData?.docType,
                                            trc_doc_no: documentData?.docNo,
                                            trc_aent_code: "",
                                            trc_ent_code: documentData?.clientEntCode,
                                            trc_action: `previewed ${documentData?.docType}`,
                                            trc_remarks: `previewed ${documentData?.docType} ${documentData?.docNo}`,
                                            trc_tags: [`previewed ${documentData?.docType}`, documentData?.docNo],
                                            trc_doc_docid: documentData?.docId
                                        });

                                        const chosenFormat =
                                            selectedFormats[report._id] || report.report_format;

                                        const chosenBackground =
                                            backgroundSettings[report._id] ||
                                            report.report_background;

                                        try {
                                            const docRes = await newRequest.post(
                                                `/gendocs/${report?.rd_endpoint}`,
                                                {
                                                    rd_name: report?.rd_name,
                                                    report_file_name: report?.rd_file_name,
                                                    report_file_path: report?.rd_file_path,
                                                    report_key: report?.report_key,
                                                    format: chosenFormat || 'pdf',
                                                    background: chosenBackground,
                                                    ...documentData,
                                                },
                                                {
                                                    responseType: 'json',
                                                }
                                            );

                                            // console.log(`0 docRes\n${JSON.stringify(docRes.data, null, 2)}`);

                                            const data = docRes.data;

                                            // Background mode
                                            if (data?.job_status === "queued") {
                                                setIsProcessing(false);
                                                setNotifyDialogTitle(t("note"));
                                                setNotifyDialogText(chosenBackground === "Y" ? t('reportGenBackground') : t('reportGenConvBackground'));
                                                setIsNotifyDialogOpen(true);
                                                return; // skip file handling
                                            }

                                            // Error mode
                                            if (data?.job_status === "error") {
                                                setIsProcessing(false);
                                                setNotifyDialogTitle("Error");
                                                setNotifyDialogText(data.job_msg || "Report generation failed");
                                                setIsNotifyDialogOpen(true);
                                                return;
                                            }

                                            // console.log("Document generated successfully");

                                            // Foreground mode: decode base64 buffer
                                            if (data?.buffer && data?.mimeType) {
                                                setIsProcessing(false);
                                                setBinaryDocid(data.docId);

                                                const byteArray = Uint8Array.from(atob(data.buffer), c => c.charCodeAt(0));
                                                const blob = new Blob([byteArray], { type: data.mimeType });
                                                const url = URL.createObjectURL(blob);

                                                if (data.mimeType.toLowerCase().startsWith("application/pdf")) {
                                                    setPdfUrl(url);
                                                    setPdfPreviewDialogOpen(true);
                                                } else if (data.mimeType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                    const link = document.createElement("a");
                                                    link.href = url;
                                                    link.download = data.fileName || report?.rd_name.replace(".docx", ".xlsx");
                                                    link.click();
                                                    URL.revokeObjectURL(url);
                                                }
                                                // console.log("saved doc_id:", data.docId);
                                            } else {
                                                throw new Error("No buffer/mimeType in response");
                                            }
                                        } catch (error) {
                                            setIsProcessing(false);
                                            console.log("error:", error);
                                            if (error.response?.status === 404) {
                                                setNotifyDialogTitle("Error");
                                                setNotifyDialogText(`Endpoint not setup for ${report?.rd_name}`);
                                            } else if (error.response) {
                                                setNotifyDialogTitle("Error");
                                                setNotifyDialogText(`Error: ${error.response.status} - ${error.response.statusText}`);
                                            } else if (error.request) {
                                                setNotifyDialogTitle("Error");
                                                setNotifyDialogText("No response from server. Please check your network.");
                                            } else {
                                                setNotifyDialogTitle("Error");
                                                setNotifyDialogText(`Request error: ${error.message}`);
                                            }
                                            setIsNotifyDialogOpen(true);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                    }
                                }}
                            >
                                <IconComponent className="sub-menu-icon" />
                                <div className="sub-menu-content">
                                    <div className="sub-menu-name">{report?.rd_name}</div>
                                    <div className="sub-menu-description">
                                        {report?.rd_description}
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px", alignItems: "center", justifyContent: "space-between" }}>
                                        {/* Format selector */}
                                        {report.report_format_change === "Y" && (
                                            <div style={{ marginTop: "5px" }}>
                                                <label
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <input
                                                        type="radio"
                                                        value="pdf"
                                                        checked={currentFormat === "pdf"}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            handleFormatChange(report._id, "pdf");
                                                        }}
                                                    />{" "}
                                                    {t('pdf')}
                                                </label>
                                                <label
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <input
                                                        type="radio"
                                                        value="xlsx"
                                                        checked={currentFormat === "xlsx"}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            handleFormatChange(report._id, "xlsx");
                                                        }}
                                                    />{" "}
                                                    {t('excel')}
                                                </label>
                                            </div>
                                        )}
                                        {/* Background toggle */}
                                        {report.report_background === "Y" &&
                                            <div style={{ marginTop: "5px" }} onClick={(e) => e.stopPropagation()}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={currentBackground === "Y"}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            handleBackgroundToggle(report._id);
                                                        }}
                                                    />{" "}
                                                    {t('background')}
                                                </label>
                                            </div>}
                                    </div>
                                </div>
                                <div className="sub-menu-arrow">
                                    <MoveRight size={20} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
            {/* email component */}
            {emailDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('email').toUpperCase()}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setEmailDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} fetchEmails={fetchEmails} />
                        </div>
                    </div>
                </motion.div>
            )}
            {pdfPreviewDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper pdf">
                        <div className="overlay-navbar">
                            <div className="left">
                                <h1 className="main-title">{t('preview').toUpperCase()}</h1>
                            </div>
                            <div className="right" style={{ gap: "5px" }}>
                                {binaryDocid &&
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="both"
                                        variant="tint"
                                        color="#E040FB"
                                        tooltip="Share on WhatsApp"
                                        endIcon={<ImWhatsapp />}
                                        onClick={() => setWhatsAppDialogOpen(true)}>
                                        {t('share')}
                                    </CustomLoadingButton>}
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#7CB342"
                                    tooltip="Send to email"
                                    endIcon={<MdAlternateEmail />}
                                    onClick={() => {
                                        try {
                                            const urlString = pdfUrl.toString().replace("blob:", "");
                                            setEmailData({
                                                to: documentData?.clientEmail,
                                                from: currentUser?.usr_org_name,
                                                cc: '',
                                                bcc: '',
                                                subject: `${documentData?.docType} No ${documentData?.docNo}`,
                                                show_attach: "N",
                                                attached_urls: [{ id: 1, url: urlString, name: `${documentData?.docType} No ${documentData?.docNo}`, binary_docid: binaryDocid }],
                                                binary_docs: [{ doc_id: binaryDocid, doc_name: `${documentData?.docType} No ${documentData?.docNo}`, doc_type: "pdf", doc_url: "", doc_size_kb: 0 }],
                                                doc_no: documentData?.docNo,
                                                doc_type: documentData?.docType,
                                                doc_id: documentData?.docId,
                                                entity_codes: [documentData?.clientEntCode],
                                                search_string: documentData?.clientEntName + "," + documentData?.docNo,
                                                ...documentData
                                            });
                                            setPdfPreviewDialogOpen(false);
                                            setEmailDialogOpen(true);
                                        } catch (error) {
                                            console.log(error)
                                        }
                                    }}>
                                    {t('email')}
                                </CustomLoadingButton>
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#00BCD4"
                                    tooltip="Download report"
                                    endIcon={<MdDownload />}
                                    onClick={() => {
                                        try {
                                            const link = document.createElement('a');
                                            link.href = pdfUrl;
                                            link.download = `${documentData?.docType} ${documentData?.docNo}.pdf`;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        } catch (error) {
                                            console.log(error)
                                        }
                                    }}>
                                    {t('download')}
                                </CustomLoadingButton>
                                <hr className='separator-v' />
                                <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={() => setPdfPreviewDialogOpen(false)}
                                    icon={<MdClose />}
                                    width={"35px"}
                                    height={"35px"} />
                            </div>
                        </div>
                        <div className="overlay-content-pdf" >
                            <PdfPreview pdfUrl={pdfUrl} />
                        </div>
                        <div className="overlay-actions">
                        </div>
                    </div>
                </motion.div>
            )}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
                        <ScaleLoader
                            color="var(--primary)"
                            height={50}
                            radius={8}
                            width={4}
                        />
                    </div>
                </motion.div>)}
            {whatsAppDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <div className="left">
                                <span className="main-title">{t("shareToWhatsApp")}</span>
                            </div>
                            <div className="right">
                                <CircularButton currentTheme={currentTheme} onClick={() => setWhatsAppDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                            </div>
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label">
                                <input
                                    id="to"
                                    name="to"
                                    type="text"
                                    placeholder={t("to")}
                                    value={to}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={(e) => setTo(e.target.value)}
                                />
                            </div>
                            <div className="input-item-with-label">
                                <textarea
                                    id="message"
                                    name="message"
                                    type="text"
                                    placeholder={t("message")}
                                    value={message}
                                    rows={3}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={handleContentChange}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleDocumentShare();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <span>{charCount} {t("characters")}</span>
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                onClick={handleDocumentShare}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#F50057"
                                tooltip={`Share document to ${to}`}
                                endIcon={<BsFillSendFill />}
                            >
                                {t("share")}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notifyDialogText) }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        endIcon={<MdClose />}
                        onClick={() => setIsNotifyDialogOpen(false)}>
                        {t('close')}
                    </CustomLoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default OnScreenReports;
